import { useState } from "react"
import { useAppSelector } from "../../../../lib/redux/hooks"
import { Layout } from "../../../../ui/layout"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { HorizontalTab } from "../../../../ui/organisms/horizontalTab"
import { Tab } from "react-tabs"
import clsx from 'clsx'
import { UnitaProduttiveList } from "../unitaProduttive"
import { StruttureList } from "../strutture"
import { ZootecniaList } from "../zootecnia"
import { PreparazioneList } from "../preparazione"
import { ContoTerziLists } from "../contoTerzi"
import { ImportazioneList } from "../importazione"
import { Particelle } from "../particelle"
import { CustomHorizontalTab } from "../../../../ui/organisms/customHorizontalTab"
import { NotifyStatus } from "../stato/view"
import { ComparazioneNotifiche } from "../comparazione"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { useNavigate } from "react-router-dom"

export function NotifyBioEdit() {
    const sessionState = useAppSelector(state => state.session)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const navigate = useNavigate()

    if (sessionState.selected.customerId) {
        return (
            <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche', 'Dettaglio Notifica']}
                noPaddingLat
                headerLabel="Notifiche"
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
                headerIcon={
                    <button style={{ paddingTop: '12px' }} onClick={() => navigate('/notify')}>
                        <ArrowLeftIcon />
                    </button>
                }
            >
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Stato</div>
                    <div>Unità Produttive</div>
                    <div>Particelle</div>
                    <div>Strutture</div>
                    <div>Zootecnia</div>
                    <div>Preparazione</div>
                    <div>Conto Terzi</div>
                    <div>Importazione</div>
                    <div>Acquacoltura</div>
                    <div>Controllo Notifiche</div>
                </CustomHorizontalTab>

                <div className="fieldset bg-brandPrimary-200">
                    {
                        selectedTab === 0 &&
                            <NotifyStatus />
                    }
                    {
                        selectedTab === 1 &&
                        <UnitaProduttiveList />
                    }
                    {
                        selectedTab === 2 &&
                        <Particelle />
                    }
                    {
                        selectedTab === 3 &&
                        <StruttureList />
                    }
                    {
                        selectedTab === 4 &&
                        <ZootecniaList />
                    }
                    {
                        selectedTab === 5 &&
                        <PreparazioneList />
                    }
                    {
                        selectedTab === 6 &&
                        <ContoTerziLists />
                    }
                    {
                        selectedTab === 7 &&
                        <ImportazioneList />
                    }
                    {
                        selectedTab === 8 &&
                        <></>
                    }
                    {
                        selectedTab === 9 &&
                        <ComparazioneNotifiche />
                    }
                </div>
            </Layout>
        )
    }

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche', 'Dettaglio Notifica']}
            noPaddingLat
            headerLabel={"Notifiche"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}